import { createURLParams } from '@scripts/frontend/libs/utils'
import { endpoint } from '@shared/services/endpoint'
import { getRequest, putRequest } from '@shared/services/fetcher'
import useSWR from 'swr'
import useSWRMutation from 'swr/mutation'

import type { Order } from './type'

export enum FilterOrderStatusEnum {
  All = 'all',
  CancelRefunded = 'cancel-refunded',
  Completed = 'completed',
  PendingPayment = 'pending-payment',
  Processing = 'processing',
}

export type GetOrderRequest = {
  limit?: number
  page?: number
  status?: FilterOrderStatusEnum
}

export function useOrder() {
  // const useGetOrder = () => {
  //     const {
  //         data,
  //         error,
  //         isMutating: isLoading,
  //         trigger,
  //     } = useSWRMutation<CreateCheckoutResponse, Error, string, CheckoutFormValues>(
  //         endpoint.frontend.CHECKOUT.INDEX,
  //         sendRequest,
  //     );

  //     const checkout = async (request: CheckoutFormValues) => {
  //         return await trigger(request);
  //     };

  //     return { checkout, data, error, isLoading };
  // };

  // const useOrderReceived = (request: OrderReceivedRequest) => {
  //     return useSWR<Order, Error, string>(endpoint.frontend.CHECKOUT.ORDER_RECEIVED, async (url) => {
  //         return await fetch(url, {
  //             body: JSON.stringify(request),
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //             method: 'POST',
  //         }).then((res) => res.json());
  //     });
  // };

  const useGetOrder = (request: GetOrderRequest) => {
    const params = createURLParams(request)
    return useSWR<Order[], Error, string>(
      `${endpoint.frontend.ORDERS}?${params}`,
      getRequest,
    )
  }

  const useGetOrderById = (orderId: string) => {
    return useSWR<Order, Error, string>(
      `${endpoint.frontend.ORDERS}/${orderId}`,
      getRequest,
    )
  }

  const useCancelOrder = (orderId: string) => {
    const {
      data,
      error,
      isMutating: isLoading,
      trigger,
    } = useSWRMutation<unknown, Error, string>(
      `${endpoint.frontend.ORDERS}/${orderId}/cancel`,
      putRequest,
    )

    const cancel = async () => {
      return await trigger()
    }

    return { cancel, data, error, isLoading }
  }

  return {
    cancelOrder: useCancelOrder,
    getOrder: useGetOrder,
    getOrderById: useGetOrderById,
  }
}
